import { IFS } from './types';
import { isFunction } from 'ramda-adjunct';

export function createLazyFs(): IFS {
  let actions = [];
  let lastFsInstance = window.FS;

  Object.defineProperty(window, 'FS', {
    configurable: true,
    get: () => lastFsInstance,
    set: (value) => {
      lastFsInstance = value;
      if (!lastFsInstance) {
        return;
      }
      actions.forEach(([method, params]) => {
        if (lastFsInstance && isFunction(lastFsInstance[method])) {
          lastFsInstance[method](...params);
        }
      });
      actions = [];
    },
  });

  function callFs(method) {
    return (...params) => {
      if (lastFsInstance && isFunction(lastFsInstance[method])) {
        lastFsInstance[method](...params);
      } else {
        actions.push([method, params]);
      }
    };
  }

  return {
    setUserVars: callFs('setUserVars'),
  };
}
